import Animated from 'react-native-reanimated';
import styled from 'styled-components/native';

import { Color } from '~/components/color';

export const ContentScrollView = styled(Animated.ScrollView)`
    background-color: ${Color.BACKGROUND_DEFAULT};
    flex: 1;
`;
